import React from 'react';
import styled from 'styled-components';
import line from '../../assets/repairBonus/line.png';
import CTALink from '../CTALink';
import routes from '../../Routes';
import { Button, tabletThresholdPixels, colors } from './v4/styledComponents';

const HowItWorksContainer = styled.div`
  width: 100vw;
  background: #F7F5F1;
  padding-bottom: 40px;
  margin: 128px 0px 0px;
  text-align: center;
  @media (max-width: ${tabletThresholdPixels}) {
    padding: 40px;
    margin: 40px 0px 0px;
    width: calc(100vw - 80px);
  }
`;

const Title = styled.h2`
  font-size: 60px;
  color: ${colors.black};
  margin: 96px auto 64px;
  text-align: left;
  width: 1180px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 40px;
    width: 100%;
    margin: 0 auto;
  }
`;

const ProcessContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin: 0 auto 40px;
  width: 1160px;
  height: 400px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    height: 100%;
    flex-direction: column;
  }
`;

type ProcessStepType = {
  step: number;
};
const ProcessStep = styled.div<ProcessStepType>`
  position: absolute;
  width: 27%;
  ${({ step }) => step % 2 ? 'top: 200px' : ''};
  ${({ step }) => step % 2 ? '' : 'bottom: 200px'};
  left: ${({ step }) => (step - 1) * 25}%;
  @media (max-width: ${tabletThresholdPixels}) {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }
`;

const StepTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 12px;
`;

const StepDescription = styled.p`
  font-size: 16px;
`;

const Img = styled.img`
  @media (max-width: ${tabletThresholdPixels}) {
    display: none;
  }
`;

const Ul = styled.ul`
  padding-left: 20px;
  margin: 0;
`;

type HowItWorksSectionType = {
  yellowButton?: boolean;
};

const HowItWorksSection = ({ yellowButton }: HowItWorksSectionType) => (
  <HowItWorksContainer>
    <Title>COMMENT ÇA MARCHE ?</Title>
    <ProcessContainer>
      <Img src={line} alt="ligne" />
      <ProcessStep step={1}>
        <StepTitle>VOS ARTICLES ONT BESOIN D‘UNE RÉPARATION ?</StepTitle>
        <StepDescription>
          Confiez vos produits à nos artisans:
          <Ul>
            <li>
              En rendez-vous à domicile ou par envoi de colis en commandant sur tilli.fr
            </li>
            <li>Dans nos boutiques</li>
          </Ul>
        </StepDescription>
      </ProcessStep>
      <ProcessStep step={2}>
        <StepTitle>NOS ARTISANS RÉPARENT VOS ARTICLES</StepTitle>
        <StepDescription>Vous êtes tenus informé de la progression de votre commande par mail.</StepDescription>
      </ProcessStep>
      <ProcessStep step={3}>
        <StepTitle>LA RÉDUCTION DU BONUS RÉPARATION EST IMMÉDIATE</StepTitle>
        <StepDescription>Vous n‘avez rien à faire, c‘est automatiquement déduit du montant de votre réparation, Tilli s‘occupe de tout !</StepDescription>
      </ProcessStep>
      <ProcessStep step={4}>
        <StepTitle>VOS PRODUITS SONT PRÊTS</StepTitle>
        <StepDescription>Bravo vous avez prolongé la durée de vie de votre produit tout en économisant jusqu‘à 25€</StepDescription>
      </ProcessStep>
    </ProcessContainer>
    <CTALink to={routes.Step1.url} fromInteraction="repair-bonus_how-it-works">
      <Button yellow={yellowButton} dark={!yellowButton}>Profiter du bonus réparation</Button>
    </CTALink>
  </HowItWorksContainer>
);

HowItWorksSection.defaultProps = {
  yellowButton: false,
};

export default HowItWorksSection;
